import {InstallerType} from 'interfaces'
import {i18n} from 'i18n'

const {t} = i18n

export const getInstallerLabel = (bundle: InstallerType): string => {
  switch (bundle) {
    case InstallerType.Mac:
      return t('common:APPLE')
    case InstallerType.Windows:
      return t('common:WINDOWS')
    case InstallerType.WindowsArm:
      return t('common:WINDOWS_ARM')
    default:
      return t('common:DOWNLOAD')
  }
}
